export const environment = {
  production: true,
  apiUrl: 'https://dev-chicagocubs.groupsales.service.3ddigitalvenue.com/api',
  oktaData: {
    clientId: '0oa1jbndylhbtMYt30h8',
    issuer: 'https://qa-ids.mlb.com/oauth2/ausg0y0s07iKGqVKv0h7',
  },
  analytics: {
    club: [],
    mmc: '',
  }
};
